<loading-overlay>
  <div class="loading animated-fast fadeIn">
    <loading-spinner></loading-spinner>
  </div>
  <script>
    import 'tags/common/loading-spinner'
    import './style.scss'
  </script>
</loading-overlay>